module.exports = __webpack_public_path__ + "static/media/icon-20.8a5f6740.svg";